/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import { DreiMonatsdurchschnittFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/DynamischeStundenbewertung/DreiMonatsDurchschnittFields';
import { WochendurchschnittFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/DynamischeStundenbewertung/WochendurchschnittFields';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  DYNAMISCHE_ABWESENHEIT_ARTEN,
  DynamischeAbwesenheitArt,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/dynamischeAbwesenheitstypen';
import { FieldLabel, RadioGroup, RadioGroupItem } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function DynamischeStundenbewertung() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <form.AppField
      name="abwesenheiten.allgemein.dynamisch"
      listeners={{
        onChange: () => {
          ctx.resetDependentFields('abwesenheiten.allgemein.dynamisch');
        },
      }}>
      {(field) => (
        <FieldBase>
          <div className="relative">
            <RadioGroup
              className="gap-4"
              value={field.state.value}
              onValueChange={(val) =>
                field.handleChange(val as DynamischeAbwesenheitArt)
              }
              onBlur={field.handleBlur}>
              <div className="flex gap-2">
                <RadioGroupItem
                  value={DYNAMISCHE_ABWESENHEIT_ARTEN.tagesschnitt}
                  id={field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.tagesschnitt}
                />
                <div className="flex flex-col gap-2">
                  <FieldLabel
                    className="text-neutrals-900 text-sm font-semibold leading-5"
                    htmlFor={
                      field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.tagesschnitt
                    }>
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.tagesdurchschnitt.label',
                    )}
                  </FieldLabel>
                  <span className="text-neutrals-800 text-sm font-normal leading-5">
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.tagesdurchschnitt.description',
                    )}
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <RadioGroupItem
                  value={DYNAMISCHE_ABWESENHEIT_ARTEN.wochenschnitt}
                  id={field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.wochenschnitt}
                />
                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <FieldLabel
                      className="text-neutrals-900 text-sm font-semibold leading-5"
                      htmlFor={
                        field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.wochenschnitt
                      }>
                      {t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.wochendurchschnitt.label',
                      )}
                    </FieldLabel>
                    <span className="text-neutrals-800 text-sm font-normal leading-5">
                      {t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.wochendurchschnitt.description',
                      )}
                    </span>
                  </div>
                  {field.state.value ===
                    DYNAMISCHE_ABWESENHEIT_ARTEN.wochenschnitt && (
                    <WochendurchschnittFields />
                  )}
                </div>
              </div>
              <div className="flex gap-2">
                <RadioGroupItem
                  value={DYNAMISCHE_ABWESENHEIT_ARTEN.drei_monatsschnitt}
                  id={
                    field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.drei_monatsschnitt
                  }
                />
                <div className="flex flex-col gap-5">
                  <div className="flex flex-col gap-2">
                    <FieldLabel
                      className="text-neutrals-900 text-sm font-semibold leading-5"
                      htmlFor={
                        field.name +
                        DYNAMISCHE_ABWESENHEIT_ARTEN.drei_monatsschnitt
                      }>
                      {t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.label',
                      )}
                    </FieldLabel>
                    <span className="text-neutrals-800 text-sm font-normal leading-5">
                      {t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.description',
                      )}
                    </span>
                  </div>
                  {field.state.value ===
                    DYNAMISCHE_ABWESENHEIT_ARTEN.drei_monatsschnitt && (
                    <DreiMonatsdurchschnittFields />
                  )}
                </div>
              </div>
              <div className="flex gap-2">
                <RadioGroupItem
                  value={DYNAMISCHE_ABWESENHEIT_ARTEN['12_monatsschnitt']}
                  id={
                    field.name +
                    DYNAMISCHE_ABWESENHEIT_ARTEN['12_monatsschnitt']
                  }
                />
                <div className="flex flex-col gap-2">
                  <FieldLabel
                    className="text-neutrals-900 text-sm font-semibold leading-5"
                    htmlFor={
                      field.name +
                      DYNAMISCHE_ABWESENHEIT_ARTEN['12_monatsschnitt']
                    }>
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.12_monatsdurchschnitt.label',
                    )}
                  </FieldLabel>
                  <span className="text-neutrals-800 text-sm font-normal leading-5">
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.12_monatsdurchschnitt.description',
                    )}
                  </span>
                </div>
              </div>
            </RadioGroup>
          </div>
        </FieldBase>
      )}
    </form.AppField>
  );
}
